export const USER_INPUT_ACTION_TYPE_ID = '0-170857045';